var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VBtn",
    {
      staticClass: "documentation-button-component text--text",
      attrs: {
        color: _vm.color,
        href: _vm.href,
        target: "_blank",
        small: _vm.small
      }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.label) + " "),
      _c("KmIcon", {
        staticClass: "ml-2",
        attrs: { size: 18, name: "km-icon-support" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }